import { ProductManagementListMenuStructure } from "../store";
import { PRODUCT_MANAGEMENT_LIST_MENU } from '../actions-constants/productManagementListMenu.constants'
const initialProductManagementListMenuStructure: ProductManagementListMenuStructure = new ProductManagementListMenuStructure



export function productManagementListMenuReducer(productManagementListMenu: ProductManagementListMenuStructure = initialProductManagementListMenuStructure, action): ProductManagementListMenuStructure {

  switch (action.type) {


    case PRODUCT_MANAGEMENT_LIST_MENU.SET_INITIAL_STATE_MENU:
      return {
        ...productManagementListMenu,
        stateMenu: action.stateMenu
      }

    case PRODUCT_MANAGEMENT_LIST_MENU.SET_FILTERS:
      return {
        ...productManagementListMenu,
        filters: action.filters
      }

    case PRODUCT_MANAGEMENT_LIST_MENU.SET_INITIAL_SITUATION:
      return {
        ...productManagementListMenu,
        situacao: action.situacao
      }

    case PRODUCT_MANAGEMENT_LIST_MENU.SET_INITIAL_ACQUISITION_COST:
      return {
        ...productManagementListMenu,
        custoPadrao: action.custoPadrao
      }

    default:
      return productManagementListMenu
  }
}